import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
    filterMonths: {
        marginLeft: '12px',
        width: '400px',
        height: '60px'
    },
    optionAutocomplete: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    },
    containerChipsScroll: {
        overflowY: 'scroll',
        maxHeight: '40px',
        display: 'flex',
        flexWrap: 'wrap'
    }
}))
